export default "__VITE_ASSET__CVjri7nQ__"